"use client";

import React, { useState } from 'react';

const ReadMore = ({ children, maxCharCount = 150 }) => {
    const text = children;
    const [isExpanded, setIsExpanded] = useState(false);

    // Vérifier si le texte dépasse la limite de caractères
    const needsReadMore = text?.length  > maxCharCount;

    // Obtenir le texte à afficher (tronqué ou complet)
    const displayText = isExpanded || !needsReadMore
        ? text
        : `${text.substring(0, maxCharCount)}...`;

    return (
        <div className="mb-6">
            <p className="mb-2 leading-relaxed whitespace-pre-line">{displayText}</p>

            {needsReadMore && (
                <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="text-primary hover:underline text-sm font-medium focus:outline-none"
                >
                    {isExpanded ? 'Voir moins' : 'Voir plus'}
                </button>
            )}
        </div>
    );
};

export default ReadMore;